import Vue from 'vue'

export default Vue.extend({
	data: () => ({
		isMobile: false
	}),
	beforeMount(): void {
		this.onWindowResize()
		window.addEventListener('resize', this.onWindowResize)
		this.$once('hook:destroyed', () => {
			window.removeEventListener('resize', this.onWindowResize)
		})
	},
	methods: {
		onWindowResize(): void {
			this.isMobile = window.innerWidth <= 991
		}
	}
})
